import * as React from 'react'
import { Blob } from "@rails/activestorage";
import { useDropzone } from 'react-dropzone'
import styled, { css } from "styled-components"
import { MimeTypes } from '../../types'
import { ActiveStorageController } from '../../controllers'
import { HELPCENTER_OPEN_GRAPH_IMAGE_FILE_SIZE, MAX_FILE_SIZE } from '../../Constants';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { Style } from '../../styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ImageContainer = styled.div<{ attachmentPresent?: boolean, light?: boolean }>`
  max-width: 350px;
  max-height: 200px;
  min-height: 100px;
  display: flex ;
  cursor: pointer;
  border: 1px solid ${Style.color.border};
  cursor: pointer;

  ${props => props.attachmentPresent && css`
    max-width: fit-content;
  `}

  ${props => props.light && css`
    background: #14161a;
  `}

  ${props => !props.light && css`
    background: white;
  `}
`
const OpenGraphImage = styled.img`
  max-width: 100%;
  max-height: 200px;
`

interface IProps {
  url: string
  onSubmit: (blob: Blob) => void
  accept: MimeTypes[]
  maxSize: number
  light?: boolean
}

const AttachmentUploader = (props: IProps) => {
  const { t } = useTranslation()
  const { url, onSubmit, accept, maxSize, light } = props

  const onDrop = async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0]

    if (file) {
      ActiveStorageController.uploadPublic(file, async (error, blob) => {
        if (error) { console.error(error) }
        if (blob) onSubmit(blob)
      })
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    multiple: false,
    accept: accept,
    maxSize: maxSize || MAX_FILE_SIZE,
  })

  const onDeleteClick = () => {
    onSubmit(null)
  }

  return (
    <Container>
      <ImageContainer {...getRootProps()} light={light} attachmentPresent={!!url}>
        {url && <OpenGraphImage src={url} />}
      </ImageContainer>
      <input type='file' {...getInputProps()} />

      {url && <span style={{ marginTop: 16 }}>
        <Button
          type='default'
          text={t('OpenGraphImageUploader::Remove this image')}
          icon='trash'
          onClick={onDeleteClick}
        />
      </span>}
    </Container>
  )
}

export default AttachmentUploader